/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiSortDirection {
    ASC = 'ASC',
    DESC = 'DESC'
}


export function instanceOfInternalApiSortDirection(value: any): boolean {
    for (const key in InternalApiSortDirection) {
        if (Object.prototype.hasOwnProperty.call(InternalApiSortDirection, key)) {
            if (InternalApiSortDirection[key as keyof typeof InternalApiSortDirection] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiSortDirectionFromJSON(json: any): InternalApiSortDirection {
    return InternalApiSortDirectionFromJSONTyped(json, false);
}

export function InternalApiSortDirectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiSortDirection {
    return json as InternalApiSortDirection;
}

export function InternalApiSortDirectionToJSON(value?: InternalApiSortDirection | null): any {
    return value as any;
}

export function InternalApiSortDirectionToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiSortDirection {
    return value as InternalApiSortDirection;
}

